module.exports = __webpack_public_path__ + "static/media/rocket.bb611de9.svg";